define('rebrush/components/layout/navigation',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/components/PubSubHub',
	'cartware/jquery/bem',
	'json!shoptheme/etc/breakpoints.json',
	'enquire',
	'jquery-menu-aim',
	'modernizr',
	'bootstrap-collapse',
	'jquery-dlmenu'
], function(
	$,
	_,
	Component,
	PubSubHub,
	BEM,
	BreakPoints,
	enquire,
	menuAim
) {
	var isMobile = true;
	var MENU_ANIMATION = '3';

	return Component.create({
		blocks:					null,
		path:					null,
		area:					null,
		additionalCategories:	null,
		topmenu:				null,
		desktopAimInitialized:	false,

		$init: function() {
			this.blocks = BEM.block('nav');
			this.path = _.get(window, 'gigaset.category.current');
			this.area = _.get(window, 'gigaset.area');
			this.additionalCategories = _.get(window, 'gigaset.category.additional');
			this.topmenu = $('#topmenu');
			this.headerMenuTriggerBlock = BEM.block('header-menu-trigger');
			this.headerMenuTriggerButton = this.headerMenuTriggerBlock.getElements('button');
			this.recommendationsBlock = BEM.block('search-autocomplete-recommendations');

			var self = this;
			_.forEach(_.union(this.path, [this.area], this.additionalCategories), _.bind(function(categoryId) {
				var nodeId = ((categoryId|0) == categoryId)
					? 'category-node-' + categoryId
					: categoryId;

				self.blocks.find('[data-category-id="' + nodeId + '"]').bemAddModifier('active');
			}, this));

			// jQuery('#topmenu').data("dlmenu").openMenu()
			this.topmenu.dlmenu({
				animationClasses : { classin : 'dl-animate-in-' + MENU_ANIMATION, classout : 'dl-animate-out-' + MENU_ANIMATION },
				useActiveItemAsLink: true
			});

			this.bindEvents();
			this.initResponsive();
			this.prepareCustomerAccountNavigation();
			this.desktopMenuAim();
		},

		bindEvents: function() {
			var menuItemClass = '.' + BEM.buildElementClassname('nav', 'menu-item', 'level0'),
				dlmenu = this.topmenu.data('dlmenu'),
				button = this.headerMenuTriggerButton,
				$body = $(document.body),
				self = this;

			$(document).on('mouseenter', menuItemClass, function(e) {
				$(e.currentTarget).addClass('hover');
			}).on('mouseleave', menuItemClass, function(e) {
				$(e.currentTarget).removeClass('hover');
			});

			if (dlmenu) {
				button.on('click', _.bind(function (e) {
					e.preventDefault();
					e.stopPropagation();

					if (dlmenu.open) {
						dlmenu.closeMenu();
					}  else {
						dlmenu.openMenu();
					}
				}, this));

				dlmenu
					.on('open', function() {
						button.addClass('is-active');
						$body.addClass('topmenu-mobile-open');
						PubSubHub.trigger.apply(PubSubHub, ['layout.topmenu.mobile.open'].concat(Array.prototype.slice.call(arguments)));
						if (!self.recommendationsBlock.hasModifier('hidden')) {
							self.recommendationsBlock.addModifier('hidden');
						}
					})
					.on('close', function() {
						button.removeClass('is-active');
						$body.removeClass('topmenu-mobile-open');
						PubSubHub.trigger.apply(PubSubHub, ['layout.topmenu.mobile.close'].concat(Array.prototype.slice.call(arguments)));
						if (self.recommendationsBlock.hasModifier('hidden')) {
							self.recommendationsBlock.removeModifier('hidden');
						}
					});

				$(document.body).on('keyup', _.bind(function(e) {
					var isEscape = ('key' in e) ?
						(e.key === 'Escape' || e.key === 'Esc') :
						(e.keyCode === 27);

					if (isEscape && dlmenu.open) {
						e.preventDefault();
						dlmenu.closeMenu();
					}
				}, this));
			}

			// Optimization for touch devices on desktop breakpoints (e.g. iPad Pro) on level 0
			;(function() {
				var parentMenuItemSelector = '.' + BEM.buildElementClassname('nav', 'menu-item', 'parent');
				var parentMenuItemLinkSelector = parentMenuItemSelector + ' a';

				$(document.body).on('touchstart', parentMenuItemLinkSelector, function(e) {
					if (isMobile) {
						return;
					}

					var link = $(e.currentTarget),
						menuItem = link.parents(parentMenuItemSelector);

					if (!menuItem.hasClass('hover')) {
						link.one('click', function(ev) {
							ev.preventDefault();
						});
					}
				});
			})();

			// Optimization for touch devices on desktop breakpoints (e.g. iPad Pro) on level 1
			;(function() {
				var parentMenuItemSelector = '.' + BEM.buildElementClassname('nav', 'menu-item', 'parent');
				var parentMenuItemLinkSelector = parentMenuItemSelector + ' a';
				var subMenuSelector = '.' + BEM.buildElementClassname('nav', 'menu');

				$(document.body).on('touchstart', parentMenuItemLinkSelector, function(e) {
					if (isMobile) {
						return;
					}

					var link = $(e.currentTarget),
						subMenu = link.siblings(subMenuSelector);

					if (subMenu.length && !subMenu.hasClass('open')) {
						link.one('click', function(ev) {
							ev.preventDefault();
						});
					}
				});
			})();
		},

		initResponsive: function() {
			enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
				match: _.bind(this.layoutDesktop, this),
				unmatch: _.bind(this.layoutMobile, this)
			}, true);
		},

		layoutMobile: function() {
			isMobile = true;

			var menus = this.blocks.getElements('menu');
			menus.addClass('dl-submenu');
			menus.filter(':modifier(level0)').each(function() {
				var menu = $(this);
				menu.bemParents('menu-item').bemGetElements('submenu-slot-mobile').before(menu);
			});

			this.topmenu.addClass('dl-menuwrapper');
		},

		layoutDesktop: function() {
			isMobile = false;

			var menus = this.blocks.getElements('menu');
			menus.removeClass('dl-submenu');
			menus.filter(':modifier(level0)').each(function() {
				var menu = $(this);
				menu.bemParents('menu-item').bemGetElements('submenu-slot-desktop').append(menu);
			});

			this.topmenu.removeClass('dl-menuwrapper');
		},

		prepareCustomerAccountNavigation: function() {
			if ($('html').hasClass('ie8')) return;
			var customerAccountMobileNav = $('.b_account-mobile-nav');
			if (customerAccountMobileNav.length > 0) {
				customerAccountMobileNav.prependTo($('.b_main-container__col2-left-col-main'));
				$('select', customerAccountMobileNav).on('change', function() {
					window.location = $(this).val();
				});
			}
		},

		desktopMenuAim: function() {
			$(document.body).one('mouseenter', '.' + BEM.buildElementClassname('nav', 'menu-item'), _.bind(function() {
				var menus = this.blocks.getElements('menu'),
					link = BEM.buildElementClassname('nav', 'menu-item-link', 'level1');

				function activateSubmenu(row) {
					var $row = $(row),
						$submenu = $row.find('ul'),
						$menulink = $row.find('.' + link);

					if($row.hasClass('b_nav__menu-item--parent')) {
						$row.parent('ul').addClass('removeHover');
					}

					$submenu.addClass('open');
					$menulink.addClass('maintainHover');
				}

				function deactiveSubmenu(row) {
					var $row = $(row),
						$submenu = $row.find('ul'),
						$menulink = $row.find('.' + link);

					$row.parent('ul').removeClass('removeHover');
					$submenu.removeClass('open');
					$menulink.removeClass('maintainHover');

					return true;
				}

				menus.menuAim({
					activate: activateSubmenu,
					deactivate: deactiveSubmenu,
					rowSelector: '> li.' + BEM.buildElementClassname('nav', 'menu-item', 'level1'),
					exitMenu: deactiveSubmenu
				});
			}, this));
		}
	});
});
